module.exports = __webpack_public_path__ + "img/lff.06acc36e.png";